import React from 'react';
import ReactDOM from 'react-dom/client';
import reportWebVitals from './reportWebVitals';
import Homepage from './pages/homepage';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Locations from './pages/locations';
import Contact from './pages/contact';
import Apply from './pages/apply.js'
import ReturnProcess from './pages/returnProcess';
import AcceptedContainers from './pages/acceptedContainers';
import './output.css';


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <Routes>
        <Route path='/' element={<Homepage />} />
        <Route path='/locations' element={<Locations />} />
        <Route path='/contact' element={<Contact />} />
        <Route path='/apply' element={<Apply />} />
        <Route path='/returnprocess' element={<ReturnProcess />} />
        <Route path='/acceptedcontainers' element={<AcceptedContainers />} />
      </Routes>

    </BrowserRouter>

  </React.StrictMode>
);

reportWebVitals();
